module.exports = __webpack_public_path__ + "img/vue.081c348d.svg";